import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EnrollForm from '../../components/EnrollForm/EnrollForm';
import WorkflowLanding from '../../components/WorkflowLanding/WorkflowLanding';
import { subscriberEnrollingSelector } from '../../ExperianSelector';
import { setSubscriberEnrolling } from '../../ExperianActions';
import ExperianContext from '../../ExperianContext';

const Enroll = () => {
  const subscriberEnrolling = useSelector(subscriberEnrollingSelector);

  const { subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();
  const resetSubscriberEnrolling = useCallback(() => dispatch(setSubscriberEnrolling('')), [
    dispatch,
  ]);

  return (
    <>
      <WorkflowLanding />
      <EnrollForm
        isOpen={subscriberEnrolling === subscriberId}
        onCancel={resetSubscriberEnrolling}
      />
    </>
  );
};

export default Enroll;
